import React from 'react';

interface WheelOfFortuneHistoryTableHeaderProps {
  columns: string[];
}

const WheelOfFortuneHistoryTableHeader: React.FC<WheelOfFortuneHistoryTableHeaderProps> = ({ columns }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-start tw-gap-5 tw-self-stretch tw-px-2.5">
      {columns.map((column, index) => {
        return (
          <div
            key={index}
            className="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-center tw-gap-2.5 tw-px-2.5"
          >
            <div className="tw-w-full tw-justify-center tw-text-center tw-font-['Rajdhani'] tw-text-[10px] tw-font-bold tw-leading-4 tw-text-white lg:tw-text-lg">
              {column}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WheelOfFortuneHistoryTableHeader;
